/** Call a Supabase edge function (works for guest users with anon key). */
export async function callEdgeFunction(
  functionName: string,
  body: Record<string, unknown>
): Promise<{ data: Record<string, unknown> | null; error: Error | null }> {
  const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
  const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
  if (!supabaseUrl || !supabaseAnonKey) {
    return { data: null, error: new Error('Supabase not configured') };
  }
  try {
    const response = await fetch(`${supabaseUrl}/functions/v1/${functionName}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        apikey: supabaseAnonKey,
        Authorization: `Bearer ${supabaseAnonKey}`,
      },
      body: JSON.stringify(body),
    });
    const data = await response.json().catch(() => null);
    if (!response.ok) {
      const err = Object.assign(
        new Error(data?.error || `Request failed with status ${response.status}`),
        { status: response.status, responseBody: data, functionName }
      );
      return { data: null, error: err as Error };
    }
    return { data, error: null };
  } catch (err) {
    return { data: null, error: err instanceof Error ? err : new Error(String(err)) };
  }
}
